var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-relative-100"},[_c('SubHeader',{attrs:{"title":"내 찜 목록"}}),_c('div',[_c('SearchList',{attrs:{"list":_vm.list}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }